import { createSelector } from '@reduxjs/toolkit'

export const usersPageSelector = (state) => state.usersPage

const statisticsSelector = createSelector(usersPageSelector, ({ statistics }) => statistics)
export const totalUserCountSelector = createSelector(statisticsSelector, ({ users }) => users)
export const totalInvitationCountSelector = createSelector(statisticsSelector, ({ invitations }) => invitations)
export const totalMigrationCountSelector = createSelector(statisticsSelector, ({ migrations }) => migrations)
